import { LEARN_BASICS, LEARN_RETIRED_ARTICLES } from '@cc/schema';

/**
 * E34 · the Learn articles a practice can assign as a READING (the Assign drawer's Target picker for
 * `kind: reading` — "readings list the Learn articles (E15)").
 *
 * E56 (Learn 2, founder Q-learn-7): the picker offers ONLY the active Basics articles — the 22 of
 * `@cc/schema` `LEARN_BASICS`, generated from the articles themselves, so a new article needs no line here. The
 * phone's catalogue is bundled; these ids and titles are the same list, shared through `@cc/schema` (the founder's
 * ruling on portal/mobile sharing, 2026-09-10). The id is what the assignment carries
 * (`target {type:"article", ref: id}`) and what the phone opens; each title is under `homework.articles.<id>`
 * (portalEn / portalRu — derived, see `learnArticleTitles`).
 *
 * A RETIRED id (16 → 22: two replaced, nine moved to the website, two retired) is never offered, but an old
 * assignment that names one still reads by its title: `LEARN_ARTICLE_LABEL_IDS`.
 */
export const LEARN_ARTICLE_IDS: readonly string[] = LEARN_BASICS.map(a => a.id);

/** Every id that has a `homework.articles.<id>` title: the active Basics, then the retired ones. */
export const LEARN_ARTICLE_LABEL_IDS: readonly string[] = [
  ...LEARN_ARTICLE_IDS,
  ...Object.keys(LEARN_RETIRED_ARTICLES),
];

export type LearnArticleId = string;
